import { ApplicationFilters } from "stores/ApplicationFilters/ApplicationFiltersStore";
import { ExtendedMetadataClassifier } from "models/ClassifierModel";

export const getExtendedMetadataKey = (filterKey: string) =>
    filterKey.startsWith("extendedMetadata.")
        ? filterKey.replace("extendedMetadata.", "")
        : undefined;

export const getGroupedExtendedMetadataValue = (
    filters: Pick<ApplicationFilters, "extendedMetadataGrouped">,
    filterKey: string,
) => {
    const key = getExtendedMetadataKey(filterKey);
    if (!key) return undefined;
    return filters.extendedMetadataGrouped?.[key];
};

export const hasGroupedExtendedMetadataValues = (
    filters: Pick<ApplicationFilters, "extendedMetadataGrouped">,
    filterKey: string,
) => {
    const groupedValue = getGroupedExtendedMetadataValue(filters, filterKey);
    return !!groupedValue && groupedValue.values.length > 0;
};

export const isGroupableExtendedMetadataField = (
    fields: ExtendedMetadataClassifier[],
    filterKey: string,
) => {
    const key = getExtendedMetadataKey(filterKey);
    if (!key) return false;
    const field = fields.find((item) => item.name === key);
    return !!field?.isGroupable;
};
